export default __webpack_public_path__ + "assets/images/5563ea291f6f17f2752bb5ad47736dc9.svg";